export const downloadCSV = (fileName: string, csvData: string) => {
  const blob = new Blob(["\ufeff", csvData]);
  createDownloadLink(fileName, blob);
};

export const downloadPDF = (fileName: string, pdfData: string) => {
  const blob = new Blob([base64ToBlob(pdfData)], { type: "application/pdf" });
  createDownloadLink(fileName, blob);
};

export const downloadPNG = (fileName: string, dataUrl: string) => {
  createPngDownloadLink(fileName, dataUrl);
};

const createPngDownloadLink = (fileName: string, dataUrl: string) => {
  const downloadLink = document.createElement("a");
  downloadLink.href = dataUrl;
  downloadLink.download = fileName;
  downloadLink.click();
  downloadLink.remove();
};

const createDownloadLink = (fileName: string, blobData: Blob) => {
  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(blobData);
  downloadLink.download = fileName;
  downloadLink.click();
  downloadLink.remove();
};

const base64ToBlob = (base64str: string) => {
  const binary = atob(base64str);
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  return view;
};
